export const API_URL = "https://tovis.com.br";

export const api = {
  login: `${API_URL}/auth/login`,
  me: `${API_URL}/auth/me`,
};
